import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../common/Icon";
import useAuth from "../../hooks/useAuth";

const ROLE_LABELS = {
  ADMIN: "مدیر سامانه",
  CLUB_MANAGER: "مدیر باشگاه",
};

function getUserName(user) {
  return (
    user?.fullName ||
    user?.name ||
    user?.firstName ||
    user?.email ||
    "مدیر سامانه"
  );
}

function getInitials(name) {
  if (!name) return "م";

  const parts = name.trim().split(/\s+/);

  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`;
  }

  return parts[0][0];
}

export default function AdminHeader({ onMenuClick, collapsed }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const userName = getUserName(user);

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <header
      dir="rtl"
      className="glass sticky top-0 z-40 mx-3 mt-3 flex h-[64px] shrink-0 items-center rounded-full px-3 sm:px-5 md:mx-0 md:mt-0"
    >
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <button
          type="button"
          onClick={onMenuClick}
          className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-ink text-white shadow-lg shadow-ink/25 transition-all hover:scale-105 md:hidden"
          aria-label="باز کردن منوی مدیریت"
        >
          <Icon name="menu" className="h-5 w-5" />
        </button>

        

        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <div className="hidden h-10 w-10 shrink-0 items-center justify-center rounded-full bg-ink text-floodlight shadow-md shadow-ink/20 sm:flex">
              <Icon name="dashboard" className="h-5 w-5" />
            </div>

            <div className="min-w-0">
              <h1 className="truncate text-sm font-black text-ink sm:text-base">
                پنل مدیریت
              </h1>

              <p className="hidden text-xs text-slate-400 sm:block">
                سامانه مدیریت هیئت فوتبال شهرستان پاوه
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex shrink-0 items-center gap-2 sm:gap-3">
        <div className="hidden items-center gap-2 rounded-full bg-emerald-500/10 px-3.5 py-2 lg:flex">
          <span className="h-2 w-2 animate-pulse rounded-full bg-emerald-500" />

          <span className="text-xs font-semibold text-emerald-700">
            سیستم فعال
          </span>
        </div>

        <div className="hidden h-8 w-px bg-slate-200 sm:block" />

        <div className="flex items-center gap-2">
          <div className="hidden text-left md:block">
            <p className="text-sm font-bold text-slate-800">
              سلام، {userName}
            </p>

            <p className="mt-0.5 text-[11px] text-slate-400">
              {ROLE_LABELS[user?.role] || user?.role || "مدیر سامانه"}
            </p>
          </div>

          <div className="grid h-10 w-10 place-items-center rounded-full bg-gradient-to-br from-floodlight to-emerald-400 text-sm font-black text-ink shadow-md">
            {getInitials(userName)}
          </div>
        </div>

        <button
          type="button"
          onClick={handleLogout}
          className="group flex h-10 items-center gap-2 rounded-full bg-red-50 px-4 text-sm font-bold text-red-600 transition-all hover:bg-red-500 hover:text-white hover:shadow-lg hover:shadow-red-500/25"
          title="خروج از حساب"
        >
          <Icon
            name="logOut"
            className="h-4 w-4 transition-transform group-hover:-translate-x-0.5"
          />

          <span className="hidden sm:inline">
            خروج
          </span>
        </button>
      </div>
    </header>
  );
}